import React from 'react'

const RootContext = React.createContext({})
const FormContext = React.createContext({})

export { RootContext, FormContext }
